<template>
  <div class="bread">
<!--    <template v-if="tableData.length === 0 || column.length === 0 && summary.length < 3 || column.length > 0 && tableData.length < 3">-->
    <template v-if="tableData.length === 0 || column.length === 0 && summary.length < 3">
      <div class="nodata">
        <span>
          <img src="https://bigdata.topeti.com/PCRepository/defaultSvg/Intersect.svg" />
          <div>暂无数据</div>
        </span>
      </div>
    </template>

    <!-- 柱状图表格 -->
    <template v-else-if="tableData.length>0">
      <div id="columnarChart"
           ref="columnar"
           class="columnarChart"
           :style="{width: isMobile ? '355px' : '100%', height: isMobile ? (h + 'px') : '100%'}"></div>
    </template>

  </div>
</template>

<script>
import * as echarts from 'echarts'
import macaronsDatas from './json/echartColor.json'
import {chartRadar} from './js/color.js';
let chartsModel = "";
// var curInt = null;


export default {
  name: 'radarCpn',
  props: {
    h: Number,
    //- 分组字段数据
    row: {
      type: Array,
      default: ()=>[]
    },
    //- 汇总字段数据
    summary: {
      type: Array,
      default: ()=>[]
    },
    //- drage组件大小修改后，饼图实时更新
    changeSize: {
      type: Number,
      default: 0
    },
    //- 表格数据
    tableData: {
      type: Array,
      default: ()=>[]
    },
    //- 表id
    id: {
      type: Number,
      default: 0
    },
    //- isFrontEnd是否为前端或者后端展示:true为后端,false为前端
    isFrontEnd: {
      type: Boolean,
      default: ()=>false
    },
    viewShow: {
      type: Boolean,
      default: ()=>false
    },
    selectIndex: {
      type: Number,
      default: ()=>null
    },
    user: {
      type: Array,
      default: () => []
    },
    width: [String, Number],
    isMobile: {
      type: Boolean,
      default: false
    },
    theme: Object,
    column: {
      type: Array,
      default: () => []
    }
  },
  data: function () {
    return {
      myChart: '',
      nameArray: [],

    }
  },
  mounted() {
    console.log("this.selectIndex==>",this.selectIndex);
    // if(this.selectIndex){
    //     curInt = this.selectIndex;
    // }
    this.$nextTick(()=>{
      this.openFunBread();
    })

  },
  methods: {
    updateFun(){
      console.log("更新");
      if (this.myChart.resize) this.myChart.resize();

    },
    //- 打开图表
    openFunBread(){
      console.log("openFun",this.tableData.length);
      if(this.tableData.length <= 25 && this.tableData.length > 0){
        this.$nextTick(()=>{
          this.initData();
        })

      }

    },
    // series 值动态计算
    getSeries (xAxisData) {
      const data = this.column.length > 0 ? chartRadar({date: this.tableData, column: this.column, summary: this.summary, xAxisData: xAxisData}) : this.tableData.map(its => {
        const ars = JSON.parse(JSON.stringify(its))
        delete ars.name
        return {
          name: its.name,
          value: Object.values(ars),
        }
      })
      const series = [
        {
          name: '',
          symbol: 'circle',
          type: 'radar',
          data: data,
        }
      ]
      return series
    },
    getMax () {
      let max = 0
      let nameArray = []
      let legend = []
      for (let i = 0; i < this.tableData.length; i++) {
      // for (const s of this.tableData) {
        const s = this.tableData[i]
        if (this.column.length === 0) {
          nameArray.push(s.name)
          const ite = JSON.parse(JSON.stringify(s))
          delete ite.name
          const maxVal = Math.max(...Object.values(ite))
          if (maxVal > max) max = maxVal
        } else {
          for (let e = 0; e < s.length; e++) {
            const item = s[e]
            if (item) {
              nameArray.push(item.name)
              legend.push(item[this.column[0].revisabilityName])
              const ite = JSON.parse(JSON.stringify(item))
              delete ite.name
              delete ite[this.column[0].revisabilityName]
              const maxVal = Math.max(...Object.values(ite))
              if (maxVal > max) max = maxVal
            }
          }
        }
      }
      nameArray = Array.from(new Set(nameArray))
      legend = Array.from(new Set(legend))
      return {
        nameArray: nameArray,
        max: max,
        legend: legend
      }
    },
    getRadar (info) {
      if (this.column.length > 0) {
        const arr = []
        for (const i of info.nameArray) {
          arr.push({
            name: i,
            max: info.max + 1
          })
        }
        return arr
      } else {
        return this.summary.map(item => {
          return {
            name: item.name,
            max: info.max + 1
          }
        })
      }
    },
    //- 创建图表
    initData() {
      const info = this.getMax()
console.log('返回配置数据', info, this.tableData, JSON.stringify(this.tableData))
      console.log('返回配置indicator:', this.getRadar(info), 'series:', this.getSeries(info.nameArray))
      chartsModel = "";
      this.$nextTick(()=>{
        // 基于准备好的dom，初始化echarts实例
        let dom = this.$refs.columnar;
        if (!dom) {
          console.log('不存在dom1',this.tableData.length === 0 || this.column.length === 0 && this.summary.length < 3)
          console.log('不存在dom', dom, JSON.parse(JSON.stringify(this.tableData.length)))
          return;
        }
        echarts.registerTheme('macarons', macaronsDatas.theme)
        chartsModel = echarts.init(dom,'macarons');
        let option = {
          tooltip: {},
          legend: {
            show: true,
            type: 'scroll',
            top: '0',
            left: 'right',
            data: info.legend,
            textStyle:{
              color: '#333'
            }
          },
          radar: {
            name: {
              formatter: (val) => {
                return val ? val.split(/\1{1}/g).join('') : val
              }
            },
            triggerEvent: true,
            indicator: this.getRadar(info)
          },
          series: this.getSeries(info.nameArray)
        };

        if (this.theme && this.theme.axes) {
          option.legend.textStyle.color = this.theme.titleColor
          option.color = this.theme.color

        }

        console.log('雷达图配置', option, info.nameArray)

        chartsModel.clear();
        // 绘制图表
        chartsModel.setOption(option);
        chartsModel.off("click");
        chartsModel.on("click", (param)=>{
          //- 设置柱状图点击事件
          if(this.isFrontEnd === true){
            return;
          }
          console.log("柱状图点击事件=====>",param, option.radar, param.event.topTarget, param.event.topTarget._dimIdx, option.radar.indicator[param.event.topTarget.__dimIdx]);


          this.relevanceFun(param.name,param.value,param.dataIndex, option.radar.indicator[param.event.topTarget.__dimIdx]);
        });
        this.myChart = chartsModel;
        this.$forceUpdate();
      })
    },
    //- 饼图点击事件，在客户端时候需要筛选查询该表单设置的对应关联表单
    relevanceFun(name,val,index, indicator){
      console.log('点击解析', name, val, index, indicator)
      if(this.isFrontEnd === true){
        return;
      }
      // let rowName = this.row[0].name;
      let summaryName = this.summary[0].name;
      let array = {};
      const nameArr = indicator.name && typeof indicator.name === 'string' ? indicator.name.split(/\1{1}/g) : []
      console.log('行列赋值', this.row, nameArr)
      for (let i = 0; i < this.row.length; i++) {
        const nes = this.row[i].name
        console.log('行赋值', nes, nameArr[i])
        array[nes] = nameArr[i]
      }
      console.log('列赋值', this.column, val)

      for (let i = 0; i < this.column.length; i++) {
        const nes = this.column[i].revisabilityName || this.column[i].name
        array[nes] = val[i]
      }
      array[summaryName] = val[index]
      // array[rowName] = name;
      // array[summaryName] = val;
      let date = {
        id: this.id,
        value: array,
        selectIndex: index
      }
      if (this.user[index]) date.user = this.user[index]
      console.log('回传,', date)
      this.$emit("relevanceFun",date)
    }
  },
  watch: {
    changeSize(val) {
      console.log("w===>",val)
      if(this.tableData.length>0){
        setTimeout(() => {
          this.updateFun();

        }, 1000);

      }

    },
    'tableData':{
      handler (newV) {
        // do something, 可使用this
        console.log(newV)
        if(newV && newV.length>0){
          this.$nextTick(()=>{
            this.$forceUpdate();
            this.openFunBread();
          })
        }

      },
      deep:true

    },
    'selectIndex': {
      handler(newName) {

        console.log("变话了",newName)
        this.$nextTick(()=>{
          this.$forceUpdate();
          this.initData();
        })
      },
      deep:true
    },
    viewShow: {
      immediate: true,
      handler () {
        this.updateFun()
      }
    },
    width: {
      immediate: true,
      handler () {
        this.updateFun()
      }
    },
    theme: {
      immediate: true,
      deep: true,
      handler () {
        console.log('配置更新')
        this.initData();
      }
    },
  }
}
</script>

<style scoped lang="scss">
.bread {
  width: 100%;
  height: 100%;
  position: relative;

}
.nodata {
  width: 100%;
  text-align: center;
  color: #666666;
  //line-height: 244px;
  height: 100%;
  position: relative;
  span{
    display: inline-block;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    margin-left: -29px;

  }
}
</style>
